export const DEFAULT_SIDEBAR_WIDTH = 280
export const MIN_SIDEBAR_WIDTH = 280
export const MAX_SIDEBAR_WIDTH = 420

const STORAGE_KEY = 'autosquare_admin_sidebar_width'

export function clampSidebarWidth(value) {
  const width = Number(value)
  if (!Number.isFinite(width)) return DEFAULT_SIDEBAR_WIDTH
  return Math.min(MAX_SIDEBAR_WIDTH, Math.max(MIN_SIDEBAR_WIDTH, Math.round(width)))
}

export function loadSidebarWidth(storage) {
  const storedWidth = storage?.getItem(STORAGE_KEY)
  return storedWidth === null || storedWidth === undefined
    ? DEFAULT_SIDEBAR_WIDTH
    : clampSidebarWidth(storedWidth)
}

export function saveSidebarWidth(storage, value) {
  const width = clampSidebarWidth(value)
  storage?.setItem(STORAGE_KEY, String(width))
  return width
}
